import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { MessageOutlined, RocketOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const ChatPromoBanner = () => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === 'ru';

    return (
        <Card
            style={{
                marginBottom: 20,
                borderRadius: 15,
                background: 'linear-gradient(135deg, #1890ff 0%, #001529 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.25)',
                color: 'white',
                overflow: 'hidden'
            }}
            bodyStyle={{ padding: '20px' }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 15 }}>
                <Space align="start" size="middle">
                    <div style={{ 
                        background: 'rgba(255,255,255,0.15)', 
                        padding: '12px', 
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <MessageOutlined style={{ fontSize: 32, color: 'white' }} />
                    </div>
                    <div>
                        <Title level={4} style={{ color: 'white', margin: 0 }}>
                            {isRu ? 'Армянский анонимный чат' : 'Հայկական Անանուն Չատ'}
                        </Title>
                        <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14 }}>
                            {isRu 
                                ? 'Общайтесь анонимно, заводите новые знакомства на chat.avtodas.am' 
                                : 'Շփվեք անանուն, ձեռք բերեք նոր ծանոթություններ chat.avtodas.am-ում'}
                        </Text>
                    </div>
                </Space>
                <Button 
                    type="primary" 
                    size="large" 
                    href="https://chat.avtodas.am" 
                    target="_blank"
                    style={{ 
                        borderRadius: 8, 
                        fontWeight: 'bold', 
                        height: '45px',
                        background: '#ffffff',
                        borderColor: '#ffffff',
                        color: '#001529'
                    }}
                    icon={<RocketOutlined />}
                >
                    {isRu ? 'Перейти в чат' : 'Մուտք գործել'}
                </Button>
            </div>
        </Card>
    );
};

export default ChatPromoBanner;